function pickFirst(...values) {
  return values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
}

function buildName(profile) {
  const firstName = pickFirst(profile?.firstName, profile?.first_name);
  const lastName = pickFirst(profile?.lastName, profile?.last_name);
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();
  return fullName || pickFirst(profile?.email, profile?.uid) || '-';
}

function normalizeFile(file) {
  return {
    uid: String(pickFirst(file?.uid) || '').trim(),
    name: pickFirst(file?.name) || 'file',
    created: pickFirst(file?.created) || null,
    isCommentFile: Boolean(file?.isCommentFile),
    authorName: buildName(file?.author),
  };
}

function normalizeComment(comment) {
  return {
    uid: String(pickFirst(comment?.uid) || '').trim(),
    body: pickFirst(comment?.body) || '',
    isInternal: Boolean(comment?.isInternal),
    created: pickFirst(comment?.created) || null,
    authorName: buildName(comment?.author),
    authorUid: String(pickFirst(comment?.author?.uid, comment?.author?.id) || '').trim(),
    files: Array.isArray(comment?.files) ? comment.files.map(normalizeFile) : [],
  };
}

export function mapTicketDetailsResponse(payload) {
  const ticket = payload?.ticket ?? payload;
  if (!ticket) return null;

  return {
    uid: String(pickFirst(ticket.uid) || '').trim(),
    number: ticket.number ?? null,
    subject: pickFirst(ticket.subject) || '-',
    body: pickFirst(ticket.body) || '',
    status: pickFirst(ticket.status) || 'new',
    priority: pickFirst(ticket.priority) || 'normal',
    category: pickFirst(ticket.category) || '-',
    profileId: String(pickFirst(ticket?.profile?.uid, ticket?.profile?.id) || '').trim(),
    profileName: buildName(ticket?.profile),
    assignedId: String(pickFirst(ticket?.assigned?.uid, ticket?.assigned?.id) || '').trim(),
    assignedName: ticket.assigned ? buildName(ticket.assigned) : '',
    created: pickFirst(ticket.created, ticket.createdAt) || null,
    updated: pickFirst(ticket.updated, ticket.updatedAt) || null,
    files: Array.isArray(ticket.files) ? ticket.files.map(normalizeFile) : [],
  };
}

export function mapCommentsResponse(payload) {
  const raw = payload?.comments;
  if (Array.isArray(raw)) return raw.map(normalizeComment);
  if (raw && typeof raw === 'object') return Object.values(raw).map(normalizeComment);
  return [];
}
